var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9896 9.01008L15.4396 3.77009C14.7861 3.27226 13.9877 3.00181 13.1662 3.00001C12.3447 2.9982 11.5452 3.26513 10.8896 3.76008L4.33958 9.01008C3.85759 9.43126 3.48616 9.96413 3.25779 10.5621C3.02942 11.16 2.95107 11.8048 3.02958 12.4401L4.28959 19.9801C4.44881 20.8162 4.89021 21.5723 5.54002 22.122C6.18983 22.6717 7.00867 22.9817 7.8596 23.0001H18.4596C19.3107 22.9731 20.1276 22.659 20.7776 22.1089C21.4275 21.5588 21.8723 20.805 22.0396 19.9701L23.2996 12.4301C23.3679 11.797 23.2847 11.1568 23.0569 10.5622C22.8292 9.96754 22.4633 9.43556 21.9896 9.01008ZM13.9096 19.0001C13.9096 19.199 13.8306 19.3898 13.6899 19.5304C13.5493 19.6711 13.3585 19.7501 13.1596 19.7501C12.9607 19.7501 12.7699 19.6711 12.6293 19.5304C12.4886 19.3898 12.4096 19.199 12.4096 19.0001V16.0001C12.4096 15.8012 12.4886 15.6104 12.6293 15.4698C12.7699 15.3291 12.9607 15.2501 13.1596 15.2501C13.3585 15.2501 13.5493 15.3291 13.6899 15.4698C13.8306 15.6104 13.9096 15.8012 13.9096 16.0001V19.0001Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminHomeFilled);
export default __webpack_public_path__ + "static/media/admin_home_filled.ac4442d8c77fdc9816ac5fd671a78454.svg";
export { ForwardRef as ReactComponent };